/** A plain cigarette outline for the bottom nav. Decorative; the nav label carries the name. */
export function QuitIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      aria-hidden="true"
      className={className}
    >
      <rect x="2.5" y="13" width="15" height="4" rx="1" />
      <path d="M14 13v4M20 13v4M22 13v4M19 10c0-2 2-2 2-4" strokeLinecap="round" />
    </svg>
  );
}
